import React, { Component } from 'react';
import axios from "axios";
import styles from "./Tooltips.css"

class Carousel extends Component {
  constructor(props, context) {
  super(props, context);
      this.state = {
        isLoading: true,
        slides: ['./../../assets/images/spphotonic-darktheme.jpg',
        './../../assets/images/OutputReport600.png',
        './../../assets/images/dashboard.jpg'],
        username: "Example Name",
        myimage: "",
        myimage2: "",
        dlsimage: "",
        colorsensorimage: "",
        latestCluster: "",
        latestClusterPie: ""
        }
    }

async getImage() {

axios.get('https://sppmobilemedical-deployments-mobilehub-391175924.s3.amazonaws.com/private/us-east-1%3A2981d2a0-e9a1-43f7-99aa-5af80e7f6da1/cluster123/cluster-hash1234.png', { responseType: 'arraybuffer' })
.then(response => {
      let blob = new Blob(
        [response.data], 
        { type: response.headers['content-type'] }
      )
      let image = URL.createObjectURL(blob)
        this.setState({
          myimage: image
        });      
    })
axios.get('https://sppmobilemedical-deployments-mobilehub-391175924.s3.amazonaws.com/private/us-east-1%3A2981d2a0-e9a1-43f7-99aa-5af80e7f6da1/cluster123/conductivity_summary.png', { responseType: 'arraybuffer' })
.then(response => {
      let blob = new Blob(
        [response.data], 
        { type: response.headers['content-type'] }
      )
      let image = URL.createObjectURL(blob)
        this.setState({
          myimage2: image
        });      
    })
axios.get('https://sppmobilemedical-deployments-mobilehub-391175924.s3.amazonaws.com/private/us-east-1%3A2981d2a0-e9a1-43f7-99aa-5af80e7f6da1/cluster123/dls_summary.png', { responseType: 'arraybuffer' })
.then(response => {
      let blob = new Blob(
        [response.data], 
        { type: response.headers['content-type'] }
      )
      let image = URL.createObjectURL(blob)
        this.setState({
          dlsimage: image
        });      
    })

axios.get('https://sppmobilemedical-deployments-mobilehub-391175924.s3.amazonaws.com/private/us-east-1%3A2981d2a0-e9a1-43f7-99aa-5af80e7f6da1/cluster123/colorsensor_summary.png', { responseType: 'arraybuffer' })
.then(response => {
      let blob = new Blob(
        [response.data], 
        { type: response.headers['content-type'] }
      )
      let image = URL.createObjectURL(blob)
        this.setState({
          colorsensorimage: image
        });      
    })

axios.get('https://sppmobilemedical-deployments-mobilehub-391175924.s3.amazonaws.com/private/us-east-1%3A2981d2a0-e9a1-43f7-99aa-5af80e7f6da1/clusterdetail-0-ChemId.png', { responseType: 'arraybuffer' })
.then(response => {
      let blob = new Blob(
        [response.data], 
        { type: response.headers['content-type'] }
      )
      let image = URL.createObjectURL(blob)
        this.setState({
          latestCluster: image
        });      
    })

axios.get('https://sppmobilemedical-deployments-mobilehub-391175924.s3.amazonaws.com/private/us-east-1%3A2981d2a0-e9a1-43f7-99aa-5af80e7f6da1/clusterdetail-0-PieChart.png', { responseType: 'arraybuffer' })
.then(response => {
      let blob = new Blob(
        [response.data], 
        { type: response.headers['content-type'] }
      )
      let image = URL.createObjectURL(blob)
        this.setState({
          latestClusterPie: image
        });      
    })

}

async getSummary(user) {

  axios.get('https://sppmobilemedical-deployments-mobilehub-391175924.s3.amazonaws.com/private/us-east-1%3A2981d2a0-e9a1-43f7-99aa-5af80e7f6da1/cluster123/MLSummaryFile.json')
    .then(response => {
        console.log(response.data);
        var people = []
        for (var i =0;i < response.data['PatientCount']; i++)
        {
          people.push({name: response.data['PatientRecord:'+i],
            index:i
          })
        }
        this.setState({
          devicesConfigured: response.data['DeviceCount'],
          testSubjectsEnrolled: response.data['PatientCount'],
          totalSampleScans: response.data['ScanCount'],
          lambdaMessage: response.data['Title'],
          patientArray: people,
          username: "Example User",
          loginUsername: response.data['IdentityId']

        });
        })
}

async componentDidMount() {
    this.getSummary(this)
    this.getImage(this)
}




render()
{
    const {slides} = this.state;
    console.log(slides[0])
    return (
        <div className="container">
            <div className="row justify-content-center" style={{display:'flex'}}>
                <div className="col mr-6" >
                      <div><p>Welcome User: {this.state.username} </p><code> {this.state.loginUsername}</code></div>
                      <div><p>Devices Configured: <code> {this.state.devicesConfigured}</code></p></div>
                      <div><p>Test Subjects Enrolled: <code>{this.state.testSubjectsEnrolled}</code> </p></div>
                      <div><p>Total Sample Scans: <code>{this.state.totalSampleScans} </code> </p></div>
                      <div><p>Lambda Message:<code> {this.state.lambdaMessage} </code> </p></div> 
                    </div>


          <div class="tooltip">Scan Capture Frequency
              <div className="col my-auto">
                  <img src={this.state.myimage} style={{width:"400px"}} className="img-thumbnail" alt="clusterSummary2" />
              </div>
              <span class="tooltiptext">How often scans are captured.</span>
            </div>
          </div>
            <br/>
            <div className="row justify-content-center" style={{display:'flex'}}>
                <div class="tooltip">Dynamic Light Scattering

                <div className="col-md-4" >
                        <img src={this.state.dlsimage} style={{width:"400px"}} className="img-thumbnail" alt="dlsSummaryImage" />
                </div>
              <span class="tooltiptext">How Turbid is the Fluid</span>
            </div>


              <div className="row justify-content-center" style={{display:'flex'}}>
                <div class="tooltip">Conductivity Sensor Data
                  <div class="col-md-4">
                    <img src={this.state.myimage2} style={{width:"400px"}} className="img-thumbnail" alt="conductivityImage" />
                  </div>
              <span class="tooltiptext">How Conductive is the Fluid</span>
              </div>
                <div class="tooltip">Color Sensor Data
                <div className="col-md-4">
                    <img src={this.state.colorsensorimage} style={{width:"400px"}} className="img-thumbnail" alt="colorSensorSummaryImage" />
                </div>
              <span class="tooltiptext">How does the fluid absorb different frequencies of light.</span>
            </div>

            </div>

</div>
            <div className="row justify-content-center my-3" style={{display:'flex'}}>
                            <div class="tooltip">Chemical Constituents Identified Summary

                <div className="col-md-3 my-auto" >
                        <img src={this.state.latestClusterPie} style={{width:"400px"}} className="img-thumbnail" alt="latestClusterPieChart" />
                </div>
                              <span class="tooltiptext">Chemical Constituents Identified Summary</span>
            </div>

                            <div class="tooltip">SERS Spectrum

                <div className="col-md-9">
                        <img src={this.state.latestCluster} style={{width:"800px"}} className="img-thumbnail" alt="latestClusterDetailImage" />
                </div>
                              <span class="tooltiptext">Chemical Compsition as Identified by SERS Spectrum</span>
            </div>


            </div>
        </div>
    )
}
}

export default Carousel;